export default __webpack_public_path__ + "static/media/013-dentist.6c44df5e.svg";